'use client';

// imports
import { useAtom } from "jotai";

// lib files
import { searchResultsAtom, searchResultsStatus } from "@/lib/atoms/search-results";
import { ShowRowContent } from "@/lib/types/api/show-data";

// components
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import SearchFilters from "@/components/Search/SearchFilters/SearchFilters";
import SearchInput from "@/components/Search/SearchInput/SearchInput";
import SearchPagination from "@/components/Search/SearchPagination/SearchPagination";
import SearchRequest from "@/app/(main)/search/SearchRequest";
import SearchShowResults from "@/components/Search/SearchShowResults/SearchShowResults";
import SearchVideoAndWebResults from "@/components/Search/SearchVideoAndWebResults/SearchVideoAndWebResults";
import ShowRow from "@/components/ShowRow/ShowRow";

// styles
import styles from './SearchLanding.module.scss';
import CompanionState from "@/lib/types/atoms/companionState";
import SearchLandingError from "@/components/Search/SearchLandingError/SearchLandingError";
import { useHasMounted } from "@/lib/hooks";
interface SearchLandingProps {
  searchParams?: {
    q: string;
  };
  popularShows: ShowRowContent[];
  station: {
    id?: string;
    commonName?: string;
  };
}
function SearchLanding(props: SearchLandingProps) {
  const {
    searchParams,
    popularShows,
    station
  } = props;
  const query = searchParams?.q;
  const hasMounted = useHasMounted();
  const [searchResults] = useAtom(searchResultsAtom);
  const [resultsStatus] = useAtom(searchResultsStatus);
  const hasShowResults = searchResults?.rawResults.shows && searchResults.rawResults.shows.content.length > 0;
  const emptyOrError = [CompanionState.IsLoadedWithoutData, CompanionState.Error].includes(resultsStatus);
  const hasLoaded = searchResults !== null && resultsStatus === CompanionState.IsLoadedWithData;
  let content;
  switch (true) {
    case !query:
      content = <ShowRow shows={popularShows} title='Suggested Shows' />;
      break;
    case query && emptyOrError:
      content = <SearchLandingError query={query} />;
      break;
    case query && hasLoaded:
      content = <div className={styles.search_landing__content}>
          <SearchFilters className={styles.search_landing__filters} station={station} />
          <div className={styles.search_landing__results}>
            {hasShowResults && <SearchShowResults searchShowResults={searchResults.rawResults.shows!} />}
            <SearchVideoAndWebResults videoAndWebResults={searchResults.rawResults.videoAndWebResults!} promotedResults={searchResults.promotedResults} totalResults={searchResults.totalResults} query={query} station={station} />
          </div>
          <SearchPagination />
        </div>;
      break;
    default:
      content = <LoadingIndicator className={styles.search_landing__loading} />;
      break;
  }
  return <>
      <SearchRequest data-sentry-element="SearchRequest" data-sentry-source-file="SearchLanding.tsx" />
      <SearchInput query={query || ''} data-sentry-element="SearchInput" data-sentry-source-file="SearchLanding.tsx" />
      {content}
    </>;
}
export default SearchLanding;